<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="8">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-button
              size="sm"
              variant="outline-success"
              @click="() => (specDialogVisible = true)"
              v-if="allow('A')"
              :disabled="disabled"
            >
              <b-icon-plus></b-icon-plus>{{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-danger"
              @click="$emit('batchDel')"
              v-if="allow('D')"
              :disabled="disabled"
            >
              <i class="el-icon-delete"></i
              >{{ $l('INDEX.btn_delete') || '删除' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <choose-order-goods-spec-dialog
      :visible.sync="specDialogVisible"
      :title="$l('dialog_title_proofing_add') || '添加订单产品规格'"
      :orderCode="orderCode"
      type="checkbox"
      @confirm="confirm"
    />
  </div>
</template>

<script>
const initForm = {
  keyword: '',
}

import ChooseOrderGoodsSpecDialog from '@/views/factory/components/choose-order-goods-spec/dialog.vue'
export default {
  components: {
    ChooseOrderGoodsSpecDialog,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    orderCode: {
      type: String,
      default: '',
    },
    fabricCode: {
      type: String,
      default: '',
    },
    params: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      advqueryDialogVisible: false,
      specDialogVisible: false,
      form: {...initForm},
    }
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({isReset = true} = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    confirm(data) {
      if (!data) return
      data = data.map((row) => {
        return {
          orderGoodsSpecCode: row.orderGoodsSpecCode,
          orderGoodsCode: row.orderGoodsCode,
          fabriclCode: this.params.fabricCode,
          fabriclNo: this.params.fabricNo,
          fabriclName: this.params.fabricDisplayName,
          scmCode: this.params.scmCode,
        }
      })

      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$api
        .orderGoodsSpecFabricBatchSaveApi({
          orderCode: this.orderCode,
          fabricList: data,
        })
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.$emit('reload')
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
  },
}
</script>
